// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1-hNT","item":"PaymentsMobile_item__2S48Z","label":"PaymentsMobile_label__Fr0Le","amount":"PaymentsMobile_amount__3pWlz"};